import { SvgIcon } from '@mui/material';

const GoogleIcon = ({ children, ...props }) => (
    <SvgIcon {...props} viewBox="0 -960 960 960">
        {children}
    </SvgIcon>
);

export default GoogleIcon;
